/* P026 (21-10-2026): script van de productkaart, stond eerst in snippets/product-card.liquid bij elke kaart. Nu één keer, met defer, vanuit theme.liquid. */
  (function() {
    if (window.__productCardCroInit) return;
    window.__productCardCroInit = true;

    document.addEventListener('click', function(e) {
      var swatch = e.target.closest('[data-sibling-swatch]');
      if (!swatch) return;

      e.preventDefault();
      e.stopPropagation();

      var card = swatch.closest('product-card');
      if (!card) return;

      var siblingUrl = swatch.getAttribute('data-sibling-url');
      var siblingImage = swatch.getAttribute('data-sibling-image');
      var siblingImageSmall = swatch.getAttribute('data-sibling-image-small');
      var siblingSecondaryImage = swatch.getAttribute('data-sibling-secondary-image');
      var siblingTitle = swatch.getAttribute('data-sibling-title');

      card.querySelectorAll('[data-sibling-swatch]').forEach(function(s) {
        s.classList.remove('is-active');
      });
      swatch.classList.add('is-active');

      var primaryImage = card.querySelector('.product-card__image--primary');
      if (primaryImage && siblingImage) {
        primaryImage.classList.add('is-swapping');

        var preload = new Image();
        preload.onload = function() {
          primaryImage.setAttribute('src', siblingImage);
          if (siblingImageSmall) {
            primaryImage.setAttribute('srcset',
              siblingImageSmall + ' 400w, ' + siblingImage + ' 1000w'
            );
          } else {
            primaryImage.setAttribute('srcset', siblingImage);
          }
          primaryImage.setAttribute('alt', siblingTitle || '');
          requestAnimationFrame(function() {
            primaryImage.classList.remove('is-swapping');
          });
        };
        preload.onerror = function() {
          primaryImage.classList.remove('is-swapping');
        };
        preload.src = siblingImage;
      }

      var secondaryImage = card.querySelector('.product-card__image--secondary');
      if (secondaryImage) {
        if (siblingSecondaryImage && siblingSecondaryImage !== '') {
          secondaryImage.style.display = '';
          secondaryImage.style.visibility = '';
          secondaryImage.setAttribute('src', siblingSecondaryImage);
          secondaryImage.setAttribute('srcset', siblingSecondaryImage);
          secondaryImage.setAttribute('alt', (siblingTitle || '') + ' - alternate view');
        } else {
          secondaryImage.style.display = 'none';
        }
      }

      if (siblingUrl) {
        card.querySelectorAll('[data-product-card-link]').forEach(function(link) {
          link.setAttribute('href', siblingUrl);
        });
        card.setAttribute('handle', siblingUrl);
      }

      if (siblingTitle) {
        var titleLink = card.querySelector('.product-card__title a');
        if (titleLink) {
          titleLink.textContent = siblingTitle;
        }
      }

      var siblingPrice = swatch.getAttribute('data-sibling-price');
      var siblingCompare = swatch.getAttribute('data-sibling-compare');
      var siblingDiscount = swatch.getAttribute('data-sibling-discount');

      var priceList = card.querySelector('price-list');
      if (priceList) {
        var salePrice = priceList.querySelector('sale-price');
        if (salePrice && siblingPrice) {
          // Plain-text price (matches server-rendered markup). Preserve any .sr-only label.
          var saleSrOnly = salePrice.querySelector('.sr-only');
          salePrice.textContent = siblingPrice;
          if (saleSrOnly) {
            salePrice.insertBefore(saleSrOnly, salePrice.firstChild);
          }
        }

        var compareEl = priceList.querySelector('compare-at-price');
        if (siblingCompare && siblingCompare !== '') {
          if (!compareEl) {
            compareEl = document.createElement('compare-at-price');
            compareEl.className = 'text-subdued line-through';
            if (salePrice) {
              priceList.insertBefore(compareEl, salePrice);
            } else {
              priceList.appendChild(compareEl);
            }
          }
          // Plain-text compare-at price (matches server-rendered markup). Preserve any .sr-only label.
          var compareSrOnly = compareEl.querySelector('.sr-only');
          compareEl.textContent = siblingCompare;
          if (compareSrOnly) {
            compareEl.insertBefore(compareSrOnly, compareEl.firstChild);
          }
          compareEl.style.display = '';
        } else if (compareEl) {
          compareEl.style.display = 'none';
        }

        var badge = priceList.querySelector('.green-badge');
        if (badge) {
          if (siblingDiscount && siblingDiscount !== '') {
            badge.textContent = siblingDiscount + '% Off';
            badge.style.display = '';
          } else {
            badge.style.display = 'none';
          }
        }
      }
    });
  })();
